import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FixedWidthParser } from 'fixed-width-parser';
import { Event, TicketStatus } from '../../models';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { Utils } from '../../shared/utils';

@Injectable({
  providedIn: 'root',
})
export class FixedWidthFileParserService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  public parseDatFile(datStringContent: string) {
    const fixedWidthParser = new FixedWidthParser([
      {
        type: 'string',
        name: 'Lieu',
        start: 0,
        width: 3,
      },
      {
        type: 'string',
        name: 'Événement',
        start: 4,
        width: 6,
      },
      {
        type: 'string',
        name: 'Date d\'achat',
        start: 10,
        width: 16,
      },
      {
        type: 'string',
        name: 'Statut',
        start: 26,
        width: 1,
      },
      {
        type: 'string',
        name: 'Catégorie',
        start: 27,
        width: 2,
      },
      {
        type: 'string',
        name: 'Provenance',
        start: 29,
        width: 10,
      },
      {
        type: 'string',
        name: 'Numéro fiscal',
        start: 39,
        width: 10,
      },
      {
        type: 'string',
        name: 'Secteur',
        start: 49,
        width: 3,
      },
      {
        type: 'string',
        name: 'Rang',
        start: 53,
        width: 4,
      },
      {
        type: 'string',
        name: 'Siège',
        start: 57,
        width: 4,
      },
      {
        type: 'string',
        name: 'Prix',
        start: 65,
        width: 6,
      },
      {
        type: 'string',
        name: 'Code-barres',
        start: 74,
        width: 16,
      },
      {
        type: 'string',
        name: 'Code-barres invalide',
        start: 90,
        width: 16,
      },
    ]);
    const removeLine = (str: string, linesNbToRemove: number, fromEnd = false): string => {
      if (linesNbToRemove <= 0) {
        return str;
      }
      if (fromEnd) {
        return removeLine(str.substring(str.lastIndexOf('\n') + 1, -1 ), linesNbToRemove - 1, fromEnd);
      }
      return removeLine(str.substring(str.indexOf('\n') + 1), linesNbToRemove - 1, fromEnd);
    };
    // we need to remove first 3 lines :
    let datContent = removeLine(datStringContent, 2);
    // we need to remove empty lines at the end. 36 char minimum for lines with data
    datContent = datContent.split('\n').filter( (l) => l.length > 36).join('\n');

    let parsedDatContent = fixedWidthParser.parse(datContent) as any;

    const removeLeadingChar = (msg: string, toRemoveChar = '0'): string => {
      if (msg[0] === toRemoveChar) {
        return removeLeadingChar(msg.substring(1), toRemoveChar);
      }
      return msg;
    };
    // specify dat data are : without names, two category can have the same name
    parsedDatContent = parsedDatContent.map( (row) => ({
      Nom: 'NN',
      Prénom: 'NN',
      ...row,
      Catégorie: Utils.matCatToKey(row.Catégorie + '-' + row.Provenance + '-' + row.Prix),
      Rang: removeLeadingChar(row.Rang),
      Siège: removeLeadingChar(row.Siège),
      Secteur: removeLeadingChar(row.Secteur) !== 'NN ' ? removeLeadingChar(row.Secteur) : undefined,
    }));
    return parsedDatContent;
  }

  public removeCanceledLines(fileStringContent: string, event: Event, type: 'dat' | string) {
    const eventPlatforms = event.TicketingPlatforms
      .map( (p) => p.platform ) // get platform name
      .filter((v, i, a) => a.indexOf(v) === i) // unique name only
      .map( (p, i) => `platform[${i}]=${p}`) // query param mapping
      .join('&');
    return firstValueFrom(this.http.get<Array<{
      id: number,
      originalTicketNumber: string,
      status: TicketStatus,
    }>>(`${this.configUrl}e/a/export/json/${event.id}/0/canceled?${eventPlatforms}`))
      .then( (canceledTickets) => {
        // remove lines containing sold tickets
        const forbiddenBarcodes = canceledTickets.map( (t) => t.originalTicketNumber);
        let removedBarcodes = 0;
        const datStringContentArray = fileStringContent.split('\n').filter( (line) => {
          const toRemoveLine = forbiddenBarcodes.some( (barcode) => line.includes(barcode));
          if (toRemoveLine) {
            removedBarcodes ++;
          }
          return !toRemoveLine;
        });
        // apply specific transformation
        if (type === 'dat') {
          const newLineNumber = parseInt(datStringContentArray[0].substring(54, 59), 10) - removedBarcodes;
          const newLineNumberText = ` ${newLineNumber} lignes.`;
          datStringContentArray[0] = datStringContentArray[0].substring(0, 54) + newLineNumberText;
        }
        return datStringContentArray.join('\n');
      });
  }

}
